import "./style.scss";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  BALANCE_STALE_TIME,
  BALANCE_CACHE_TIME,
  getBalanceStats,
} from "../../../api/balance";
import Button from "@components/Button";
import StatusSwiper from "../../../components/StatusSwiper";
import NiceModal from "@ebay/nice-modal-react";
import {
  DETAILS_CACHE_TIME,
  DETAILS_REFETCH_INVERVAL,
  DETAILS_STALE_TIME,
  getUserDetails,
} from "../../../api/consumer";
import { levelMapper } from "../../../Constants";

export default function Points() {
  const [activeStatus, setActiveStatus] = useState(0);

  const { data } = useQuery({
    queryKey: ["user-details"],
    queryFn: getUserDetails,
    refetchInterval: DETAILS_REFETCH_INVERVAL,
    staleTime: DETAILS_STALE_TIME,
    cacheTime: DETAILS_CACHE_TIME,
  });

  useEffect(() => {
    setActiveStatus(data?.consumer.level);
  }, [data]);

  const { data: balanceData } = useQuery({
    queryKey: ["consumer-balance-stats"],
    queryFn: getBalanceStats,
    staleTime: BALANCE_STALE_TIME,
    cacheTime: BALANCE_CACHE_TIME,
  });

  return (
    <div className="points-wrapper">
      <div className="profile-section"></div>
      <div className="user-points-wrapper">
        <p className="title">Aktueller Kontostand</p>
        <p className="saldo">
          {data?.consumer.balance}
          <span className="saldo-points">{"P"}</span>
        </p>
        <p className="title">Dein Erfahrungsstatus und Status-Punkte</p>
        <p className="experience">
          {levelMapper.get(data?.consumer.level)} ({data?.consumer.totalPoints}
          <span className="experience-points">{"SP"}</span>)
        </p>
        <div className="btn-wrapper">
          <Button href="/coupons">Punkte für Gutscheine einlösen</Button>
          <Button
            btnClass="yellow outline"
            action={() =>
              NiceModal.show("history-modal", {
                yearly: balanceData?.yearly,
              })
            }
          >
            Siehe Punktehistorie
          </Button>
        </div>
      </div>
      <div className="user-history-wrapper">
        <p className="title">Vorteile</p>
        <StatusSwiper section={"profile"} activeStatus={activeStatus} />
      </div>
    </div>
  );
}
